import i18n from "i18next";

/**
 * Localizes a helpdesk URL based on the current i18n language.
 * French URLs (containing /fr/) are rewritten to /en/ when the app
 * is running in English (e.g. for en-UK companies).
 */
export const localizeDocLink = (url: string): string => {
    const lang = i18n.language.split("-")[0]; // 'fr' | 'en'
    if (lang === "en") return url.replace("/fr/", "/en/");
    return url;
};
